import { server_connection } from 'config';
export const GET_STUDENT_EVENT_LIST = '[STUDENT_EVENT_APP] GET STUDENT EVENT LIST';

export function getStudentEventList(student_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/event/list/' + student_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_STUDENT_EVENT_LIST,
                    payload: responseData
                })
            })
    }
}




// WEBPACK FOOTER //
// src/main/content/student/store/actions/student_event.actions.js